import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-order-item-edit',
  templateUrl: './order-item-edit.component.html',
  styleUrls: ['./order-item-edit.component.less']
})
export class OrderItemEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
